$(document).ready(function() {
  $('table').each(function() {
      // Fügt die Klasse 'table' zu jedem <table>-Element hinzu
      $(this).addClass('table');

      // Fügt die Klasse 'table-responsive' zum vorhergehenden Element hinzu
      $(this).parent().addClass('table-responsive');
  });
});

